import React, { useEffect, useRef, useState } from "react";
export default function AlumniCards({ newsItem }) {
  const paragraphRef = useRef(null);
  const [truncatedText, setTruncatedText] = useState("");

  useEffect(() => {
    const paragraph = paragraphRef.current;
    const lineHeight = parseInt(getComputedStyle(paragraph).lineHeight, 10);

    const maxHeight = lineHeight * 4;

    if (paragraph.scrollHeight > maxHeight) {
      let originalText = paragraph.textContent;
      let truncated = originalText;

      while (paragraph.scrollHeight > maxHeight && truncated.length > 0) {
        truncated = truncated.slice(0, -1); // Remove one character at a time
        paragraph.textContent = truncated + "...";
      }

      setTruncatedText(paragraph.textContent);
    } else {
      setTruncatedText(paragraph.textContent);
    }
  }, []);
  return (
    <div className="w-full bg-primary-light rounded-t-lg rounded-b-lg">
      <div className="w-full h-[184px] ">
        <img
          src={newsItem.image}
          alt={newsItem.title}
          className="w-full h-full object-cover object-center rounded-t-lg"
        />
      </div>
      <div className=" p-6 font-montserrat text-grey-normal">
        <h6 className=" font-semibold text-sm lg:text-xl mb-4">
          {newsItem.title}
        </h6>
        <p
          ref={paragraphRef}
          className=" leading-5 tracking-[0.04em] text-xs lg:text-sm text-pretty"
        >
          {truncatedText || newsItem.subContent}
        </p>
      </div>
    </div>
  );
}
